module.exports = __webpack_public_path__ + "static/media/connected.8234ed6e.jpg";